<template>
    <div>
        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-input-autocomplete
                    label="CID Primário"
                    v-model="model.cidPrimario"
                    :repository="repositories.cid"
                    :searchFields="fields.cid"
                    :validations="validations.primario"
                    :disabled="model.exportacao"
                >
                    <template v-slot:itemLabel="{ item }">
                        {{ item.codigo | formatCid }} - {{ item.nome }}
                    </template>
                </rkm-form-input-autocomplete>
            </rkm-col>

            <rkm-col cols="12">
                <rkm-form-input-autocomplete
                    label="CID Secundário"
                    v-model="model.cidSecundario"
                    :repository="repositories.cid"
                    :searchFields="fields.cid"
                    :disabled="model.exportacao"
                    :validations="validations.secundario"
                >
                    <template v-slot:itemLabel="{ item }">
                        {{ item.codigo | formatCid }} - {{ item.nome }}
                    </template>
                </rkm-form-input-autocomplete>
            </rkm-col>

            <rkm-col cols="12">
                <rkm-form-input-autocomplete
                    label="CID Terciário"
                    v-model="model.cidTerciario"
                    :repository="repositories.cid"
                    :searchFields="fields.cid"
                    :disabled="model.exportacao"
                    :validations="validations.terciario"
                >
                    <template v-slot:itemLabel="{ item }">
                        {{ item.codigo | formatCid }} - {{ item.nome }}
                    </template>
                </rkm-form-input-autocomplete>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
import { repository, object, data } from '@/mixins'
import formatsFilter from '@/filters/formats'

export default {
    filters: {
        ...formatsFilter,
    },
    created() {
        this.repositories = {
            cid: this.getConectaSusRepository('sigtap.cid')
        }
    },
    computed: {
        fields() {
            return {
                cid:  [
                    { key: 'codigo', searchable: true },
                    { key: 'nome', searchable: true },
                ],
            }
        },
        validations() {
            return {
                primario: {
                    required: true,
                },
                secundario: {
                    duplicate: [
                        this.model.cidPrimario ? this.model.cidPrimario.nome : null,
                        this.model.cidTerciario ? this.model.cidTerciario.nome : null
                    ]
                },
                terciario: {
                    duplicate: [
                        this.model.cidPrimario ? this.model.cidPrimario.nome : null,
                        this.model.cidSecundario ? this.model.cidSecundario.nome : null
                    ]
                }
            }
        }
    },
    mixins: [ repository, object, data ],
    props: {
        model: { type: Object, required: false, },
    },
}
</script>
